<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="short_id"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :show-borders="false"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Container Name" />
      <dx-column data-field="short_id" caption="Container ID" />
      <dx-column data-field="ipv4" caption="IPv4 Address" />
      <dx-column data-field="mac" caption="MAC Address" />

      <dx-master-detail :enabled="true" template="detailTemplate" />

      <template #detailTemplate="{ data }">
        <dx-data-grid
          :data-source="data.data.networks"
          :show-borders="true"
          :column-auto-width="true"
          :row-alternation-enabled="true"
          class="nested-grid"
        >
          <dx-column data-field="network_name" caption="Network Name" />
          <dx-column data-field="network_id" caption="Network ID" />
          <dx-column data-field="ipv4_address" caption="IPv4" />
          <dx-column data-field="mac_address" caption="MAC" />
          <dx-column data-field="endpoint_id" caption="Endpoint ID" />
        </dx-data-grid>
      </template>
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxMasterDetail
} from 'devextreme-vue/data-grid';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';

export default {
  name: 'DockerContainersWithNetworks',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxMasterDetail,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Docker Containers with Networks',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadContainers();
  },
  methods: {
    async loadContainers() {
      try {
        const response = await axios.get('/api/internal/docker/containers/with-networks');
        // const json = await res.json();
        this.dataSource = response.data;
      } catch (err) {
        console.error('Error loading containers with networks:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.nested-grid {
  margin: 10px 0;
  padding: 10px;
  border-top: 1px solid #ccc;
}
</style>
